<template>
  <v-container class="c-questions app-bg">
    <ol>
      <li v-for="item in value.questions" :key="item.name">
        <h3>{{ item.name }}</h3>
        <p v-if="typeof item.content === 'string'" v-html="item.content"></p>
        <div v-else>
          <p v-for="item2 in item.content" :key="item2" v-html="item2"></p>
        </div>
      </li>
    </ol>
  </v-container>
</template>

<script>
export default {
  props: {
    value: Object
  }
};
</script>

<style lang="scss" scoped>
.c-questions {
  padding-left: 40px;
  h3 {
    margin: 20px 0 5px;
    display: inline-block;
  }
  ol {
    padding-left: 0;
    list-style-type: decimal;
  }
}
</style>
